function getServerURL() {
  return "https://bruteforce-nodejs.herokuapp.com/";
}

export default getServerURL;
